angular.module("acl.visualizer.fieldSort", [
  "acl.common.filters",
  "acl.common.localize",
  "acl.common.directives",
  "acl.visualizer.style",
  "templates-visualizer",
  "ui.select",
]);
